import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--snackbar"
export default class extends Controller {
  static values = {
    autoHideDuration: { type: Number, default: 2000 },
  }

  initialize() {
    this.remove = this.remove.bind(this)
    this.hide = this.hide.bind(this)
  }

  connect() {
    this.show()

    if (this.autoHideDurationValue > 0) {
      this.timer = setTimeout(this.hide, this.autoHideDurationValue)
    }
  }

  disconnect() {
    this.clearTimer()
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  show() {
    this.element.classList.remove("hidden")
    this.element.classList.add(
      "inline-flex",
      "tdd-fx",
      "tdd-fx--fast",
      "tdd-fx--fade-in-up"
    )
  }

  hide() {
    this.clearTimer()
    this.element.addEventListener(
      "animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd",
      this.remove
    )
    this.element.classList.add("tdd-fx--fade-out-down")
  }

  remove() {
    this.element.remove()
  }
}
